export default function ModuleHero() {
  return (
    <section className="relative pt-32 pb-20 px-6 bg-gradient-to-br from-[#1A3A2E] to-[#0D1F17] overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-20 left-10 w-64 h-64 bg-[#39FF14] rounded-full blur-3xl"></div>
        <div className="absolute bottom-20 right-10 w-96 h-96 bg-[#39FF14] rounded-full blur-3xl"></div>
      </div>

      <div className="max-w-[1400px] mx-auto relative z-10">
        <div className="inline-block bg-[#39FF14]/20 border border-[#39FF14] px-5 py-2 rounded-full mb-6">
          <span className="text-sm font-medium text-[#39FF14]">MÓDULO 1</span>
        </div>

        <h1 className="text-5xl md:text-6xl font-bold text-white mb-6 leading-tight max-w-4xl">
          Fundamentos de Anatomía Funcional y Biomecánica
        </h1>

        <p className="text-xl text-gray-300 max-w-3xl mb-8 leading-relaxed">
          Comprende cómo se mueve el cuerpo humano bajo carga. Aprende a analizar ejercicios 
          desde la mecánica articular, las palancas y el torque aplicado. Este módulo te enseña 
          a pensar en términos de física aplicada al movimiento.
        </p>

        <div className="flex flex-wrap gap-6">
          <div className="flex items-center gap-3">
            <div className="w-12 h-12 bg-white/10 rounded-full flex items-center justify-center">
              <i className="ri-book-2-line text-2xl text-[#39FF14]"></i>
            </div>
            <div>
              <p className="text-sm text-gray-400">Lecciones</p>
              <p className="text-lg font-bold text-white">6 completas</p>
            </div>
          </div>

          <div className="flex items-center gap-3">
            <div className="w-12 h-12 bg-white/10 rounded-full flex items-center justify-center">
              <i className="ri-time-line text-2xl text-[#39FF14]"></i>
            </div>
            <div>
              <p className="text-sm text-gray-400">Duración estimada</p>
              <p className="text-lg font-bold text-white">4-5 horas</p>
            </div>
          </div>

          <div className="flex items-center gap-3">
            <div className="w-12 h-12 bg-white/10 rounded-full flex items-center justify-center">
              <i className="ri-bar-chart-line text-2xl text-[#39FF14]"></i>
            </div>
            <div>
              <p className="text-sm text-gray-400">Nivel</p>
              <p className="text-lg font-bold text-white">Fundamental</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}